import React, {Component} from "react";
import Header from "./Header";
import LeftMenu from "./LeftMenu";
import TasksOverview from "../components/overview/TasksOverview";
import Dealership from "../components/dealership/Dealership";
import {Route, Switch} from "react-router-dom";
import Logout from "../components/logout/Logout"
import Todo from "../components/common/todo/Todo";
import Notification from "../components/common/notification/Notification";
import PlanningManagement from "../components/planning/management/PlanningManagement";
import PlanningOverview from "../components/planning/overview/PlanningOverview";
import Intervention from "../components/interventiondetail/Intervention";
import CallCenterOverview from "../components/call-center/CallCenterOverview";
import CarParkManagement from "../components/carpark/management/CarParkManagement";
import CarParkPlanning from "../components/carpark/parkplanning/CarParkPlanning";
import CarDelivery from "../components/carpark/delivery/CarDelivery";
import ExchangeConfiguration from "../components/wheelsexchange/configuration/ExchangeConfiguration";

import "./Layout.css";
import ConfigurationCheck from "../components/configuration-check/ConfigurationCheck";
import Storage from "../services/Storage";
import ExchangeManagement from "../components/wheelsexchange/management/ExchangeManagement";

class Layout extends Component {


  render() {

    const user = Storage.getItem('user');

    const isNscAdmin = ['NSC_ADMIN'].includes(user.role)
    const isDuiAdmin= ['DUI_ADMIN'].includes(user.role)
    const isDuiServiceAdvisor = ['DUI_SERVICE_ADVISOR'].includes(user.role)
    const isCallCenterAgent = ['CALL_CENTER_AGENT'].includes(user.role)

    const isAdvisor = isDuiAdmin || isDuiServiceAdvisor;

    return (
      <div >
        <Header/>

        <LeftMenu/>

        <main role="main" className="main" id="content" tabIndex="-1">
          <Notification/>
          {(isAdvisor || isDuiAdmin) && <ConfigurationCheck/>}
        <Switch>
          {isNscAdmin && <Route exact path='/' component={Logout}/>}
          {(isAdvisor || isCallCenterAgent) && <Route exact path='/' component={isAdvisor ? TasksOverview : CallCenterOverview}/>}
          {(isAdvisor || isCallCenterAgent) && <Route exact path='/interventions' component={isAdvisor ? TasksOverview : CallCenterOverview}/>}
          {isAdvisor && <Route path='/dealership' component={Dealership}/>}
          {isAdvisor && <Route path='/planning-management' component={PlanningManagement}/>}
          {isAdvisor && <Route path='/planning-overview' component={PlanningOverview}/>}
          <Route path='/logout' component={Logout}/>
          {(isAdvisor || isCallCenterAgent) && <Route path='/interventions/:id' component={Intervention}/>}
          {isAdvisor && <Route path='/car-park-management' component={CarParkManagement}/>}
          {isAdvisor && <Route path='/car-park-planning' component={CarParkPlanning}/>}
          {isAdvisor && <Route path='/car-delivery' component={CarDelivery}/>}
          {isAdvisor && <Route path='/tire-configuration' component={ExchangeConfiguration}/>}
          {isAdvisor && <Route path='/tire-management' component={ExchangeManagement}/>}

          <Route component={Todo}/>
        </Switch>
        </main>
      </div>
    );
  }
}

export default Layout;


